/**
 * Created by ZhangJunPeng on 2017/5/22.
 */

export default {
  re_title: '會議預約',
  title_log: '智能會議',
//彈出框的國際化
  dialog_btn_ok: '確定',
  dialog_btn_cancel: '取消',
  dialog_btn_know: '知道了',
  dialog_prompt_info: '提示信息',
  dialog_warning_info: '警示信息',
  dialog_error_info: '錯誤提示',
  dialog_success_info: '提交成功',
  country_china: '中國 +86',
  country_china_hk: '中國香港 +852',

  count: '數量',
  num_of_day: '天數',

  btn_close: '關閉',
  btn_approval: '通過',
  btn_reject: '拒絕',
  btn_save: '保存',

  topic: '主題',

  pls_select: '請選擇',

//首頁國際化
  index_registration: '免費註冊',
  index_company: '公司',
  index_company_name: '公司名稱',
  index_company_domain: '公司域名',
  index_company_account: '申請人帳號',
  index_company_email: '申請人郵箱',
  index_company_phone: '申請人電話',

  index_username: '姓名',
  index_email: '郵箱',
  index_phone: '手機',
  index_staffID: 'Staff ID',
  index_image_content: '圖片內容',
  index_password_prompt: '密碼（8位以上數字及大小寫字母組合）',
  index_password_conform: '確認密碼（8位以上數字及大小寫字母組合）',
  index_agree: '同意軟件使用許可協議',
  index_previous: '上一步',
  index_next: '下一步',
  index_login_username: '用戶名',
  index_login_password: '密碼',
  index_login_basedn: '域',
  index_login_check_code: '驗證碼',
  index_remember: '記住密碼',
  index_forgot: '忘記密碼?',
  index_register_account: '註冊新賬戶',
  index_un_username: '用戶名不能為空,請重新輸入',
  index_un_password: '密碼不能為空,請重新輸入',
  index_find_password: '找回密碼',
  index_find_email: '郵箱找回',
  index_send: '發送',
  index_or: '或',
  index_find_phone: '手機找回',
  index_valid_code: '獲取驗證碼',
  index_valid_prompt: '郵箱驗證：請確認郵箱地址是否正確',
  index_submit: '提交',

  continue_extend: '繼續延長',

  index_activation: '激活',
  index_tip_email: '郵箱驗證',
  index_valid_phone: '手機驗證',
  index_tip_email_title: '郵箱驗證',
  index_valid_phone_title: '手機驗證',
  index_complete: '完成',

  index_reset_password: '重置密碼',
  index_save_continue: '保存並繼續',

  index_logo_virsical: '威思客',
  index_login: '登錄',
  index_reservation_platform: '智能會議',
  index_help: '幫助',
  index_download: '下載中心',
  index_language_shift: '中/英文切換',
  index_language_chinese: '簡體中文',
  index_language_chineseHk: '繁體中文',
  index_language_english: '英文',
  index_login_off: '註銷',
  index_domain_success: '新域已成功註冊，請激活後登錄！',
  index_domain_msm: '驗證碼已發送，請查收！',
  emil_sent: '郵件已發送，請查收！',
  index_experience: '馬上體驗',
  index_experience_0: '馬',
  index_experience_1: '上',
  index_experience_2: '體',
  index_experience_3: '驗',
  index_select_number: '選擇人數',
  index_select_0: '不限',
  index_select_1: '1-3人',
  index_select_2: '4-9人',
  index_select_3: '10+人以上',
  index_search: '搜索',
  index_reset: '重置',
  index_un_resource: '請選擇所預約資源類型',
  index_un_start: '請選開始時間',
  index_un_end: '請選擇結束時間',
  index_un_number: '請選擇預約人數',
  index_search_beijing: '北京',
  startPlaceholder: '開始日期',
  endPlaceholder: '結束日期',

  start_greater_than_end: '開始時間不能大於結束時間',
  start_greater_then_end_one_month: '查詢時間不能大於一個月',
  main_search_content: '會議室',
  main_pc_contact: '聯繫人',
  main_pc_location: '位置',
  main_content_index: '首頁',
  main_content_workspace: '會議預約',
  main_meeting_available: '可用',
  main_meeting_book: '預約',
  main_meeting_more: '展開更多',
  main_meeting_startTime: '會議時間',
  main_meeting_endTime: '結束時間',
  main_meeting_attends: '參會人數',
  main_meeting_disuse: '棄用',
  main_meeting_attends_list: '參會人名單',
  main_meeting_sign: '簽到人數',
  main_meeting_sign_rate: '簽到率',
  main_meeting_type: '類型',
  main_meeting_room_manager: '會議室管理員',
  main_meeting_use: '使用規定',
  main_meeting_attend: '參會人',
  main_meeting_holder: '申請人',
  main_meeting_title: '會議主題',
  main_meeting_room: '會議室',
  main_meeting_description: '會議說明',
  main_meeting_time_length: '會議時長',
  main_meeting_notice: '會議通知',
  main_meeting_ip: 'IP話機',
  main_meeting_remark: '備註',
  main_meeting_message: '短訊',
  main_meeting_cycle: '循環預訂',
  main_meeting_collapse: ' 向上收起',
  main_meeting_no_data: '無數據',
  main_meeting_room_rates: '費用(元/次)',
  main_meeting_cmma_type: '會議類型',
  main_meeting_cmma_normal: '普通會議',
  main_meeting_cmma_video: '視頻會議',
  main_meeting_cmma_pwd: '參會密碼',
  main_meeting_cmma_pwd_wrong: '參會密碼必須是數字',
  meeting_control_btn: '會控',
  cmma_msg_title: '編輯字幕',
  cmma_msg_label1: '顯示時長(秒)',
  cmma_msg_empty: '請輸入60字以內的消息',

  mc_table_room: '會議室',
  mc_table_region: '區域',
  mc_table_terminal: '終端',
  mc_table_number: '號碼',
  mc_table_status: '狀態',
  mc_table_option: '操作',
  mc_status_connected: '已連接',
  mc_status_ringing: '連接中',
  mc_status_unknown: '未連接',
  mc_extend_message1: '視頻會議還有{lastMinutes}分鐘結束，是否',
  mc_extend_message2: '？',
  mc_extend: '延長',
  mc_btn_start_now: '一鍵開啟',
  mc_btn_add: '添加',
  mc_btn_mute_all: '全部靜音',
  mc_btn_mute_all_cancel: '取消靜音',
  mc_btn_dial: '撥號',
  mc_btn_lock: '鎖定',
  mc_btn_unlock: '取消鎖定',
  mc_btn_layout: '分屏',
  mc_btn_rotation: '輪詢',
  mc_btn_message: '字幕',
  mc_btn_hang_up: '掛斷',
  mc_btn_release: '釋放',
  mc_btn_subtitle: '會議字幕',
  mc_btn_minute: '會議紀要',
  mc_btn_hold: '保留',
  mc_btn_ok: '確定',
  mc_btn_cancel: '取消',
  mc_btn_select: '選擇',
  mc_btn_stop: '結束',
  mc_btn_main: '主會場',
  mc_btn_speaking: '點名發言',
  mc_btn_video: '攝像頭',
  mc_btn_audio: '麥克風',
  mc_btn_redial: '重撥',
  mc_label_stop_meeting: '是否釋放會議室資源？',
  mc_label_extend: '請選擇延長時間',
  mc_label_room_select: '選擇會議室',
  mc_label_layout_model: '分屏模式',
  mc_label_rotation_setting: '輪詢設置',
  mc_label_stop_rotation: '是否結束輪詢？',
  mc_layout_prefix_full: '全局布局',
  mc_layout_prefix_1_n: '1+n分屏',
  mc_layout_prefix_equal: '對等分屏',
  mc_layout_shortcut_speakerOnly: '全屏',
  mc_layout_shortcut_telepresence: '網真',
  mc_layout_shortcut_stacked: '堆疊',
  mc_layout_shortcut_allEqual: '對等分屏',
  mc_layout_speakerOnly: '全屏布局',
  mc_layout_telepresence: '網真布局',
  mc_layout_stacked: '堆疊布局',
  mc_layout_allEqual: '對等分屏',
  mc_layout_allEqualQuarters: '2*2分屏',
  mc_layout_allEqualNinths: '3*3分屏',
  mc_layout_allEqualSixteenths: '4*4分屏',
  mc_layout_allEqualTwentyFifths: '5*5分屏',
  mc_layout_onePlusN: '1+n分屏',
  mc_layout_onePlusFive: '1+5分屏',
  mc_layout_onePlusSeven: '1+7分屏',
  mc_layout_onePlusNine: '1+9分屏',
  mc_layout_current: '當前模式',
  mc_rotation_model: '輪詢模式',
  mc_rotation_single: '單屏輪詢',
  mc_rotation_multi: '多屏輪詢',
  mc_rotation_interval: '間隔時長',
  mc_rotation_mainLayout: '主場分屏',
  mc_rotation_nums: '輪詢數量',
  mc_rotation_rotas: '被輪詢者',
  mc_rotation_allParticipants: '全部與會者',
  mc_rotation_dot: '、',
  mc_rotation_partiEnum: '{enumStr}等共計{num}個會議室',
  mc_msg_duplicate_number: '您呼叫的號碼已經在當前會議中',
  mc_msg_at_least_one: '請選擇至少一個新會議室',
  mc_msg_no_meeting: '視頻會議尚未啟動或已結束，無法執行此操作',
  mc_msg_main_warning: '只有創建會議時添加的會議室才可以設置為主會場',
  mc_msg_start_success: '視頻會議啟動成功！',
  mc_msg_start_fail_0: '視頻會議啟動失敗，資源佔用！',
  mc_msg_start_fail_1: '視頻會議啟動失敗!',
  mc_msg_start_already: '視頻會議已經啟動，無需重新啟動',
  mc_msg_no_meeting_start: '當前會議室沒有即將開始的會議，無法一鍵啟動',
  mc_msg_no_email_start: '當前用戶未設置郵箱，無法一鍵啟動',
  mc_msg_close_then_back: '當前視頻會議已結束，已退出會控頁面',
  mc_msg_calling_fail: '呼叫失敗，{roomName}已被其他會議佔用！',
  mc_msg_socket_error: '創建CMMA Webocket失敗，十秒後發起重連',
  mc_msg_success: '操作成功，請稍候...',
  mc_subtitle_language: '語言',
  mc_subtitle_translate: '翻譯',
  mc_subtitle_sublanguage: '副語言',
  mc_subtitle_language_zh: '中文-普通話',
  mc_subtitle_language_en_u: '英語-美式',
  mc_subtitle_language_en_a: '英語-澳大利亞',
  mc_subtitle_language_kr: '韓國語',
  mc_subtitle_language_jp: '日本語',
  mc_subtitle_language_my: '馬來語',
  mc_subtitle_google: '僅Google支持',
  mc_asr_config_error: '視頻空間配置異常',

  main_room_type: '會議室類型',
  main_room_capacity: '會議室容量',
  main_room_dept: '所屬組織',
  main_room_default_dept: '默認組織',
  main_sign_type: '簽到類型',
  main_is_sign: '是否簽到',
  main_open_video: '直錄播',
  main_notice_type: '提醒方式',

  main_meeting_room_placeholder_manager: '會議室管理員',

  main_menu_title: '威發預約平台',
  main_menu_title_new: '威思客智能會議',
  main_menu_add: '添加菜單',

//預約
  reserve_type_video: '視頻',

  carouser_welcome: '歡迎使用預約平台',
  carouser_welcome_1: '便捷和高效的使用方式，隨手可用的預約工具',
  carouser_welcome_2: '日曆方式呈現',
  carouser_welcome_3: '伴你隨行，更加高可視和易用性。',
  carouser_welcome_4: '在線雲化預約',
  carouser_welcome_5: '充分支持企業部署和雲端服務模式。',
  carouser_welcome_6: '客戶化設置項',
  carouser_welcome_7: '對資源和設備均支持客戶化定義管理模式。',
  carouser_welcome_8: '用戶角色管理',
  carouser_welcome_9: '使用，管理均支持基於角色控制和授權。',
  carouser_welcome_10: '移動設備應用',
  carouser_welcome_11: '支持基於安卓, IOS和網頁端訪問使用。',
  carouser_welcome_12: '分享到社交網絡',
  carouser_welcome_13: '與線上朋友，隨時隨地的溝通',

  index_bottom_1: '功能特點',
  index_bottom_2: '日曆',
  index_bottom_3: '會議室預訂',
  index_bottom_4: '網絡會議',
  index_bottom_5: '電話會議',
  index_bottom_6: '客戶化設置',
  index_bottom_7: '用戶管理',
  index_bottom_8: '統計報表',
  index_bottom_9: '移動端應用',
  index_bottom_10: '產品體驗',
  index_bottom_11: '增值服務',
  index_bottom_12: '會議展板',
  index_bottom_13: '企業V話',
  index_bottom_14: '視頻會議',
  index_bottom_15: '硬件設備基礎',
  index_bottom_16: '價格',
  index_bottom_17: '免費版',
  index_bottom_18: '標準版',
  index_bottom_19: '增強版',
  index_bottom_20: '關於我們',
  index_bottom_21: '關於公司',
  index_bottom_22: '技術支持',
  index_bottom_23: '媒體報道',
  index_bottom_24: '聯繫我們',
  index_bottom_25: '掃一掃關注威思客公眾號',
  index_bottom_26: '公 司：北京威發新世紀信息技術有限公司',
  index_bottom_27:
    '地 址：北京市東城區長安街1號東方廣場東二辦公樓19層1907-1909',
  index_bottom_28: '售前諮詢：400-685-3160',
  index_bottom_29: '郵 箱：sales@virsical.com',
  index_bottom_30: '2000-2016威發系統有限公司',
  index_bottom_31: '北京威發新世紀信息技術有限公司',
  index_bottom_32:
    '推薦使用谷歌、火狐、IE10以上版本瀏覽器，分辨率1280*800及以上。',

  account_base_info: '個人信息',
  city_zone: '城市地區',
  account_setting: '設置',
  account_user_group: '用戶管理',
  account_notice_remind: '通知提醒',
  account_server_resource: '會議室管理11111',
  account_domain_manage: '角色管理',
  account_role_setting: '角色設置',
  account_role_list: '角色列表',
  account_meeting_book: '會議代訂',
  account_meeting_manager: '會議室管理員',
  account_Authority_restriction: '權限設置',
  account_meeting_setting: '會議代訂設置',
  account_new_more_meetings: '新建同一時間預訂多個會議',
  account_meeting_manager_setting: '會議室管理員設置',
  account_s: '查看所有管轄區域會議預訂情況',
  account_p: '修改和取消所有管轄區域未開始會議',
  account_zone_add_value1: '請先保存，再進行新增',
  reservation_save: '保存',
  reservation_apply: '申請',
  reservation_send_notice: '發送通知',

  account_domain_address: '詳細地址',
  account_domain_ems: '郵政編碼',
  account_domain_telephone: '電話',
  account_domain_website: '企業網站',
  account_domain_upload: '上傳LOGO',
  account_domain_css: '皮膚',
  account_domain_css_1: '暖色',
  account_domain_css_2: '小清新',
  account_domain_css_3: '自定義',
  account_domain_lang: '語言設置',
  account_domain_date: '時間設置',
  account_app_Manager: '應用管理',

  user_id: '用戶ID',
  user_department: '部門',
  user_company: '公司',
  user_group: '用戶組',
  user_group_unit: '人',
  user_first_name: '姓',
  user_last_name: '名',
  user_position: '職位',
  user_edit: '編輯',
  user_delete: '刪除',
  user_dept_notFound: '未找到',
  user_save_prompt: '先新增或修改用戶後再保存',
  user_not_edit: '該用戶為同步數據，不允許編輯或刪除',
  resource_not_prompt: '請先新增或者編輯後再保存',

  group_name: '名稱',
  group_save_prompt: '輸入用戶組名稱後再保存',
  group_select: '請選擇用戶組',
  role_select: '請選擇用戶角色',
  role: '用戶角色',
  domain_admin: '域管理員',
  general_people: '普通用戶',
  index_delete_success: '刪除成功',
  index_save_success: '保存成功',
  index_save_failed: '保存失敗',
  index_meeting_save_failed: '預約會議失敗',
  index_sync_success: '同步成功',
  re_open: '開',
  re_close: '關',
  resource_state_open: '開鎖',
  resource_state_close: '鎖定',
  resource_open_open: '公開',
  resource_open_close: '私有',
  index_permission: '權限',
  index_device: '設備綁定',
  re_to: '至',
  booking_before: '提前',
  booking_minutes: '分鐘',

  privilege_time_limit: '可用時間範圍',
  work_time: '工作時間',
  re_from: '從',
  booking_win_num: '預訂窗口',
  booking_win: '預約窗口',
  re_shift: '提前',
  lock_win: '鎖定窗口',
  re_day: '天',
  re_day_mini: '天',
  re_hour: '小時',
  re_hour_mini: '小時',
  re_minutes: '分鐘',
  re_min: '分鐘',
  re_minutes_mini: '分鐘',
  booking_number: '預訂數量',
  expire_number: '未簽到數量',
  used_rate: '使用率',
  self_service: '自助服務',
  workflow_approve: '流程審批',
  report_permission: '報表基本權限',
  meeting_approve: '審批',
  meeting_detail: '詳情',

  cycle_booking: '循環預約',
  cycle_times: '次',
  cycle_may_booking: '可',
  bookingNum: '預約次數',
  expireNum: '棄用次數',
  max_cycle_time: '最大循環預約次數',
  max_booking_time: '最長預約時間',
  re_other_setting: '其他設置',
  re_support: '支持',
  re_sign_in: '簽到',
  re_sign_out: '簽出',
  re_delay_time: '延長最長時間',
  re_add: '新增',
  re_list: '列表',
  re_user: '用戶',
  account_info: '賬戶信息',
  re_date: '時間',
  date_lang: '時間/語言設置',
  date_lang2: '時間設置',
  re_times: '次',

  re_of: '所屬',
  re_assist: '輔助',
  re_assist_server: '輔助服務',
  re_equipment: '設備',
  re_service: '服務',
  tea_break: '茶歇',
  re_number: '人數',
  re_state_normal: '正常',
  re_state_fault: '故障',
  re_not_meeting: '目前沒有搜索到可用資源，請更改搜索條件重新搜索',
  re_personal_concat: '個人通訊錄',
  re_company_concat: '企業通訊錄',
  add_external: '添加外部參會人',
  edit_external: '編輯外部參會人',
  external_user: '外部參會人',

  error_404: '哇咔咔～頁面不見了～',
  error_tips: '請核對您輸入的頁面域名是否正確哦～',
  back_index: '返回首頁',
  manual_add: '手工新增',
  excel_import: 'Excel導入',
  download_template: '模板下載',
  re_upload: '上傳',
  re_selected: '瀏覽',
  send_invitation: '發出邀請',
  reset_password: '修改密碼',
  old_password: '原始密碼',
  new_password: '新密碼',
  sure_password: '確認密碼',
  old_password_notNull: '原始密碼不能為空！',
  new_password_notNull: '新密碼不能為空！',
  sure_password_notNull: '確認密碼不能為空！',
  sure_pwd_notEq: '新密碼與確認密碼不一致！',
  new_password_tip: '8位以上，至少有壹個數字和壹個字母',
  new_pwd_check_err: '請輸入8位以上密碼，至少包含壹個數字和壹個字母！！',
  company_info: '企業信息',
  department_info: '部門管理',
  device_info: '設備管理',
  user_init_password: '用戶初始密碼設置',
  init_password: '初始密碼',
  init_password_not_null: '初始密碼不能為空',

  my_reservation_list: '我的預約列表',
  history_list: '歷史預約列表',
  reservation_list: '預約列表',
  re_week: '周',
  re_month: '月',
  re_month_mini: '月',
  re_year: '年',
  re_year_mini: '年',
  re_date_time: '會議時間',
  re_start: '開始',
  re_end: '結束',
  re_extend: '延長',
  interval_time: '持續時間',
  regular_pattern: '定期模式',
  repeat_range: '重複範圍',
  no_end_time: '無結束日期',
  re_repeat: '重複',
  re_happen_time: '發生，生效時間',
  re_th: '第',
  re_every: '每',
  re_work_day: '每個工作日',
  re_week_day_new: '個工作日',
  re_week_th: ' 周的',
  re_week_thw: '周的',
  re_month_th: '個月的',
  re_first: '第一個',
  re_second: '第二個',
  re_third: '第三個',
  re_fourth: '第四個',
  re_sunday: '星期日',
  re_monday: '星期一',
  re_tuesday: '星期二',
  re_wednesday: '星期三',
  re_thursday: '星期四',
  re_friday: '星期五',
  re_saturday: '星期六',
  re_every_year: '每年',
  system_info: '系統消息',
  we_chat_info: '微信消息',
  email_info: '郵件消息',
  sms_info: 'SMS消息',
  re_template: '模板',
  notice_remind_set: '提醒時間設置',
  _30_minute: '30分鐘',
  _15_minute: '15分鐘',
  _10_minute: '10分鐘',
  _5_minute: '5分鐘',
  service_type_set: '服務資源類型設置',
  service_type_list: '服務資源類型列表',
  service_type_permission: '會議室預約權限設置',
  service_type_per_list: '會議室預約權限列表',
  service_res_set: '會議室設置',
  service_res_list: '會議室列表',
  service_fixed_device_list: '固定設備管理',
  service_mobile_device_list: '移動設備管理',
  service_res_permission: '服務資源權限設置',
  service_res_per_list: '服務資源權限列表',
  service_Exchange: '配置 Exchange 集成',
  service_Exchange_list: '配置 Exchange 集成列表',
  service_Office: '配置 office365 集成',
  service_Config: '配置服務',
  service_Exchange_protocol: '協議',
  service_Exchange_versions: '版本',
  service_Exchange_status: '狀態',
  service_Exchange_describe: '描述',
  service_Exchange_account: '賬號',
  service_Exchange_password: '密碼',
  service_Exchange_domain: '域名',
  service_Exchange_open: '開啟',
  service_Exchange_close: '關閉',
  service_exchange_connect: '連通性測試',
  sync_config: '同步配置',
  sync_config_port: '端口',
  sync_config_roots: '同步根',
  sync_config_roots_msg: "多個OU以','分隔",
  sync_config_oauthType: '認證方式',
  sync_config_oauthMethod: '認證類型',
  sync_config_encrypMode: '加密方式',
  sync_config_encrypMode_def: '不加密',
  sync_config_filter: '過濾器',

  device_modal_title: '設備綁定',
  device_modal_delete: '刪除',
  device_modal_cancel: '取消',
  device_modal_save: '保存',
  device_modal_save_success: '視頻設備綁定成功！',
  device_modal_save_fail: '視頻設備綁定失敗！',
  device_modal_delete_success: '視頻設備刪除成功！',
  device_modal_delete_fail: '視頻設備刪除失敗！',
  device_modal_name: '設備名：',
  device_modal_name_ph: '視頻設備名稱',
  device_modal_cucmname: '識別號',
  device_modal_cucmname_ph: '思科設備請填寫CUCM的Device Name',
  device_modal_model: '型號：',
  device_modal_primaryAddress: '號碼：',
  device_modal_primaryAddress_ph: '視頻設備號碼',
  device_modal_protocol: '協議：',
  device_modal_sipEncryption: 'SIP加密：',
  device_modal_bandWidth: '帶寬：',
  device_modal_qualityMains: '視頻分辨率：',
  device_modal_qualityPresentation: '雙流分辨率：',
  device_modal_sendDouble: '發送雙流：',
  device_modal_dualStreamMode: '雙流模式：',
  device_modal_bfcp: 'bfcp模式：',
  device_modal_name_less: '設備名不能少於3個字符',
  device_modal_name_more: '設備名不能超過50個字符',
  device_modal_name_required: '設備名不能為空',
  device_modal_cucmname_more: '識別號不能超過50個字符',
  device_modal_cucmname_required: '識別號不能為空',
  device_modal_model_required: '型號不能為空',
  device_modal_primaryAddress_required: '號碼不能為空',
  device_modal_primaryAddress_wrong: '號碼格式不正確',
  device_modal_primaryAddress_more: '號碼不能超過10個字符',
  device_modal_protocol_required: '協議不能為空',
  device_modal_sipEncryption_required: 'SIP加密不能為空',
  device_modal_bandWidth_required: '帶寬不能為空',
  device_modal_qualityMains_required: '視頻分辨率不能為空',
  device_modal_qualityPresentation_required: '雙流分辨率不能為空',
  device_modal_tip_required: 'TIP不能為空',
  device_modal_sendDouble_required: '發送雙流不能為空',
  device_modal_dualStreamMode_required: '雙流模式不能為空',
  device_modal_bfcp_required: 'bfcp模式不能為空',
  device_modal_item_ciscoOther: '思科其他',
  device_modal_item_thirdPart: '第三方',
  device_modal_item_required: '開啟',
  device_modal_item_optional: '允許',
  device_modal_item_prohibited: '關閉',
  device_modal_item_unlimited: '無限制',
  device_modal_item_dualStream: '雙通道',
  device_modal_item_singleStream: '單通道',
  device_modal_item_sandc: '服務器/客戶端模式',
  device_modal_item_server: '服務器模式',

  IP_not_empty: 'IP不能為空',
  account_not_empty: '賬戶不能為空',
  password_not_empty: '密碼不能為空',
  domain_not_empty: '域名不能為空',
  port_not_empty: '端口不能為空',
  roots_not_empty: '同步根不能為空',
  Exchange_not_empty: '請完善Exchange配置信息',

//新增內容
  operation_items: '操作項',
  upload_avatar: '上傳頭像',
  user_group_setting: '用戶組群',
  no_group: '無用戶組群',
  user_info_prompt: '請完善用戶信息的必填項',
  user_info_name: '姓和名不能同時為空',
  confirm_prompt: '請確認信息是否正確',
  reg_tel_prompt: '申請人電話格式有誤',
  reg_email_prompt: '申請人郵箱格式有誤',
  reg_domain_prompt: '公司域名已被註冊',
  company_name_prompt: '公司名稱不能為空',
  reg_account_prompt: '申請人帳號不能為空',
  company_domain_prompt: '公司域名格式不正確',
  reg_firstName_prompt: '申請人姓不能為空',
  reg_lastName_prompt: '申請人名不能為空',
  reg_userId_prompt: '申請人賬號格式不正確',
  reg_password_prompt: '申請人密碼不符合規則',
  uri_domain_prompt: '請在瀏覽器地址欄中輸入域名',
  tel_error_prompt: '電話號碼有誤，請重新輸入',
  email_error_prompt: '輸入的郵箱有誤，請重新輸入',
  password_error_prompt: '您輸入的密碼格式不正確，請重新輸入',
  userId_domain_prompt: '用戶ID域名與瀏覽器URL中的域名不一致',
  had_book: '已預約',
  not_start: '未開始',
  re_going: '進行中',
  re_done: '已結束',
  re_canceled: '已取消',
  re_auditing: '審批中',
  re_audit_failed: '未批准',
  re_audit_success: '審批已通過',
  modify_loop_meeting: '修改該系列的所有循環會議?',
  cancel_loop_meeting: '取消該系列的所有循環會議?',
  cancel_normal_meeting: '確定取消此會議嗎?',

//7月21號
  sign_out_meeting: '是否結束會議',
  cancel_meeting: '取消會議',
  book_meeting_attendee: '你當前選擇的參會人超過了會議室容量限制',
  delete_service_prompt: '是否需要刪除當前選擇的會議室？',

  not_allow_book: '不可預約',
  re_modify: '修改',
  not_allow_cycle: '不可循環',
  end_meeting_success: '結束會議成功',
  cancel_meeting_success: '取消會議成功',
//資源類型
  resource_name_meeting: '會議預訂',
  resource_name_meeting_type: '預訂方式',
  resource_name_workspace: '工位預訂',
  resource_name_visit: '訪客預訂',
  re_basic_info: '基本信息',

//timeZoneSetting 由英文翻譯過來的。
  re_time_zone_1: '(GMT -12:00) 埃尼威托克島，誇賈林環礁',
  re_time_zone_2: '(GMT -11:00) 薩摩亞，中途島',
  re_time_zone_3: '(GMT -10:00) 夏威夷',
  re_time_zone_4: '(GMT -9:00) 阿拉斯加',
  re_time_zone_5: '(GMT -8:00) 太平洋時間（美國及加拿大）',
  re_time_zone_6: '(GMT -7:00) 山地（美國和加拿大）',
  re_time_zone_7: '(GMT -6:00) 中央標準時間（美國和加拿大），墨西哥城',
  re_time_zone_8: '(GMT -5:00) 東部時間（美國和加拿大），波哥大，利馬',
  re_time_zone_9: '(GMT -4:00) 大西洋時間（加拿大），加拉加斯，拉巴斯',
  re_time_zone_10: '(GMT -3:30) 紐芬蘭島',
  re_time_zone_11: '(GMT -3:00) 巴西，布宜諾斯艾利斯，喬治敦',
  re_time_zone_12: '(GMT -2:00) 中大西洋',
  re_time_zone_13: '(GMT -1:00 小時) 亞速爾群島、佛得角群島',
  re_time_zone_14: '(GMT) 歐洲西部時間、倫敦、里斯本、卡薩布蘭卡',
  re_time_zone_15: '(GMT +1:00 小時) 哥本哈根皇家馬德里、巴黎、布魯塞爾',
  re_time_zone_16: '(GMT +2:00) 南非加里寧格勒',
  re_time_zone_17: '(GMT +3:00) 巴格達、利雅得、莫斯科、聖彼得堡',
  re_time_zone_18: '(GMT +3:30) 德黑蘭',
  re_time_zone_19: '(GMT +4:00) 阿布扎比，馬斯喀特，巴庫，第比利斯',
  re_time_zone_20: '(GMT +4:30) 喀布爾',
  re_time_zone_21: '(GMT +5:00) 葉卡捷琳堡，伊斯蘭堡，卡拉奇，塔什干',
  re_time_zone_22: '(GMT +5:30) 加爾各答、馬德拉斯、孟買、新德里',
  re_time_zone_23: '(GMT +5:45) 加德滿都',
  re_time_zone_24: '(GMT +6:00) 阿拉木圖，科倫坡，達卡',
  re_time_zone_25: '(GMT +7:00) 河內市，雅加達，曼谷',
  re_time_zone_26: '(GMT +8:00) 北京，珀斯，新加坡，香港',
  re_time_zone_27: '(GMT +9:00) 東京，漢城，大阪，札幌，雅庫茨克',
  re_time_zone_28: '(GMT +9:30) 阿德萊德，達爾文',
  re_time_zone_29: '(GMT +10:00) 海參崴東部，關島，澳大利亞',
  re_time_zone_30: '(GMT +11:00) 馬加丹，所羅門群島，新喀里多尼亞',
  re_time_zone_31: '(GMT +12:00) 奧克蘭，威靈頓，斐濟，堪察加半島',

  permission_message: '權限信息',
  re_cycle: '周期',
  loop_meeting: '循環會議',
  re_cycle_meeting: '周期會議',
  _24_hour: '24小時',
  attend_holder_conflict: '參會人和申請人衝突！',
  select_service: '選擇服務',

//7月28號
  upload_tips: '您上傳的文件名包含特殊符號，請重新上傳',
  password_different: '兩次密碼輸入不一致',
//8月2號
  re_login_use: '請登錄使用',
  select_service_permission: '請選擇服務人數',
  view_all_news: '查看所有消息',
  you_have: '你有',
  have_message_number: '條消息',
  re_ago: '前',
  re_accept: '接受',
  re_agree: '同意',
  re_refuse: '拒絕',

//會議展板
  iShow_available: '空閑',
  iShow_occupy: '佔用',
  today_events: '今日會議列表',
  iShow_book: '預訂',
  no_meeting: '無會議室信息',
  current_event: '當前會議',
  end_meeting: '結束會議',
  extend_meeting: '延長會議',
  iShow_member: '參會人',
  iShow_people: '人',
  next_meeting: '下一個會議',
  upcoming_meeting: '即將開始會議',
  member_password: '請輸入密碼',
  please_input_invite: '請輸入會議號',
  holder_password: '請輸入申請人密碼',
  iShow_ok: '確定',
  iShow_bind: '綁定',
  iShow_repairs: '是否需要報修？',
  meeting_email: '會議室郵箱',
  main_meeting_time: '會議時間',
  choose_time: '選擇時間',
  index_un_meet: '請輸入會議主題',
  index_un_attend: '請選擇參會人',
  add_holder: '選擇申請人',
  add_attend: '選擇參會人',
  search: '搜索',
  meet_console: '會議室展板控制台',
  back: '返回',

//消息中心
  message_dash: '消息中心',
  message_list: '消息列表',
  message_error_prompt: '請選擇要刪除的消息',
  message_content: '內容',
  message_receive_time: '接收時間',
  approval_check: '流程審批',
  no_check: '未審批',
  agree_check: '已審批',
  re_current: '剛剛',
  re_account: '帳戶',
  sign_success: '簽到成功',
  sign_out_success: '結束成功',
  re_send: '重新發送',
  re_tel_number: '電話號碼',
  re_tel_validate: '驗證碼',
  /*手機app*/
  fill: '請填寫',
  select: '請選擇',
  submitDel: '您確認要刪除該條記錄嗎？',
  submitCancel: '您確認要取消會議嗎？',
  roomNum: '房間人數',
  meeting_holder: '會議主持',
  add: '添加',
  all_select: '全選',
  all: '全選',
  no_data: '沒有相關數據',
  avatar: '頭像',
  tel: '手機號',
  current_version: '當前版本',
  book_meetting: '預約會議',
  phone_book: '通訊錄',
  inform_remind: '通知和提醒',
  inform_remind_con: '關於我的消息通知和提醒信息內容',
  mybook: '我的預約',
  history_book: '歷史預約',
  mybook_con: '顯示我的預約會議室列表',
  meetting_info: '會議信息',
  sweep: '掃一掃',
  sweep_con: '掃描二維碼：簽到和簽出會議',

  app_notice: '通知',
  app_remind: '提醒',
  app_no_data: '沒有相關數據',
  Weekday: '工作日',
  Everyday: '每天',
  just_start: '該功能即將發佈！',

  app_notice_pull: '下拉',
  app_notice_deliver: '釋放',

//  威思客底部統一
  product_categories: '產品方案',
  smart_conference: '智能會議',
  access_management: '訪客管理',
  smart_cubicle: '智能工位',
  smart_signage: '智能展板',
  smart_office_portal: '智能辦公平台',
  download: '產品下載',
  download_virsical: '威思客下載',
  download_v_chat: '企業V話下載',
  download_smart_signage: '智能展板下載',
  rsources: '資源下載',
  download_product: '產品彩頁下載',
  download_typical: '成功案例下載',
  interactive_center: '互動中心',
  video_center: '視頻中心',
  virsical_help_center: '威思客幫助中心',
  company_profile: '公司介紹',
  partners: '合作夥伴',
  honors_qualifications: '榮譽資質',
  news: '新聞動態',
  recruitment: '招聘信息',
  index_bottom_55: '掃描下方二維碼',
  index_bottom_56: '關注威思客公眾號',
  piece: '個',
  day: '號',
  Num: '第',
  week: '星期',
  searchBar_clear: '取消',
  loading: '加載中...',
  read: '已閱讀',
  done: '已回執',
  distance_meeting: '距離本次會議',
  wrong_Internet: '網絡異常，請檢查網絡!',

// meeting v4.2
  service_area: '所屬區域',
  service_area_name: '區域名稱',
  service_area_building_location: '樓宇位置',
  service_is_approval: '是否審批',
  service_fixed_device: '選擇固定設備',
  service_fixed_device_select: '選擇',
  creat_meeting: '新建會議',
  exact_search: '精確搜索',
  meeting_list: '會議管理',
  login_info: '登錄您的賬號',
  check_address: '請確認郵箱地址是否正確',
  meeting_room_first: '請先選擇會議室！',
  edit_meeting: '修改預約',
  view_meeting: '查看預約',
  userId: '員工工號：',
  welcome: '網易預約平台歡迎您',
  logout: '退出',
  holder_no_null: '申請人不能為空!',
  room_no_null: '會議室不能為空!',
  meeting_name_not_null: '會議主題不能為空!',
  meeting_name_less_than_3: '會議主題不能少於3個字符!',
  sign_time_no_null: '簽到時間不能為空!',
  start_time_no_available: '會議開始時間不能小於當前時間！',
  hen_people: '代訂人',
  time_limit: '時長不限',
  day_not_enable:
    '某些月份不足{ value } 天，對於這些月份，事件將被安排到該月的最後一天。',
  book_meeting_people_less: '參會人數不足,是否繼續操作？',
  book_meeting_people_more: '參會人數超出會議室限制,是否繼續操作？',
  meeting_room_delete_success: '會議室刪除成功',
  meeting_room_delete_fail: '會議室刪除失敗',
  meeting_room_off_fail: '會議室下線失敗',
  meeting_room_off_success: '會議室下線成功',

  room_types_common: '普通會議室',
  room_types_webex: 'WebEx會議室',
  room_types_acano: 'Acano會議室',
  room_types_exchange: 'Exchange會議室',
  room_types_domino_notes: 'Domino|Notes會議室',
  room_types_google_calendar: 'Google Calendar會議室',
  room_types_immediate: '紅外即占即用會議室',
  room_types_cisco_cmma: 'Cisco視頻會議室',

//search
  time_type_month: '月',
  time_type_week: '周',
  time_type_day: '日',
  time_format_M: 'YYYY[年]M[月]',
  time_format_w: 'YYYY[年]M[月]',
  time_format_d: 'LL dddd',
  time_format_week: 'dddd',
  search_unit_person: '{num}人',
  search_right_menu_details: '查看詳情',
  search_right_menu_edit: '修改會議',
  search_right_menu_cancel: '取消會議',
  time_expired: '該時間段已經過去，請選擇合適的時間創建會議！',
  search_page_end: '不要再點了，已經到頭了，沒有其他數據了。',
  reservation_submit: '確認',
  search_room_close: '此時間段內會議室不可用。',
  re_last: '最後一個',
  domain_account: '域賬號(員工工號)',
  domain_password: '域密碼(員工開機密碼)',
  quick_search: '快速搜索',
  welcome_info: '威思客智能會議歡迎您',
  index_login2: '我要登錄',
  code_tips: '短訊驗證碼已發送至您的手機',
  projector: '投影儀',
  phone: '電話',
  white_board: '白板',
  video: '視頻設備',
  error_info_new: '知道了',
  head_portrait_max: '頭像最大不能超過{num}KB',
  logo_max: 'LOGO最大不能超過{num}KB',
  background_max: '背景最大不能超過{num}MB',
  skin_max: '皮膚最大不能超過{num}MB',
  image_format_error: '圖片格式可以為jpeg/jpg/png',
  image_upload_error: '上傳失敗，請稍後重試。',
  image_upload_not_null: '請選擇人臉識別照片',
  meeting_right: '您沒有查看此會議的權限',
  upload_excel: '該功能僅支持Excel格式的文件',
  user_id_tip: '用戶ID只支持字母、數字、下劃線以及橫線',
  mobile_number_not_empty: '手機號碼不能為空',
  mobile_number_format_error: '手機號碼只能輸入數字',
  domain_user_change: '域管理員無法修改自己的角色',
  image_user_upload_info:
    '推薦上傳尺寸300*300像素，照片格式可以為jpeg/jpg/png，大小不超過500K.',
  image_bac_upload_info:
    '推薦上傳尺寸1920*1080像素，照片格式可以為jpeg/jpg/png，大小不超過2M.',
  image_logo_upload_info:
    '推薦上傳尺寸200*600像素，照片格式可以為jpeg/jpg/png，大小不超過500K.',
  more_meeting_booking: '多會議室預訂',
  no_more_meeting: '沒有可選的會議室',
  time_check: '最短30分鐘，最長180分鐘',
  id_number_not_empty: '用戶ID不能為空',
  first_name_not_empty: '姓不能為空',
  give_name_not_empty: '名不能為空',
  email_not_empty: '郵箱不能為空',
  first_given_not_empty: '姓和名不能同時為空',
  user_not_login: '用戶未登錄，請先登陸',
  meeting_extend_time_null: '會議延長時間不能為空!',
  meeting_extend_time_success: '會議延長成功!',

//iShow
  select_time: '選擇時間',
  day_time: '日期+時間',
//time out
  fetch_time_out: '請求超時，請檢查網絡。',
//會議4.3
  add_more_meeting: '添加更多會議室',
  pls_more_meeting: '請選擇區域',
  ordinary_meeting: '普通會議室',
  video_meeting: '視頻會議室',
  meeting_type: '會議室類型',
  meeting_device: '會議室設備',
  meeting_search_device: '會議室設備',
  device_baiban: '白板',
  device_touying: '投影',
  device_video: '視頻',
  device_phone: '電話',
  area_maintain: '區域維護',
  search_result: '{name}等 {num}個結果',
  meeting_management: '會議室管理員',
  meeting_rejected: '已拒絕',
  meeting_all_day: '全天會議',
  meeting_no_approved: '待審批',
  meeting_other_no_approved: '等待其他會議室管理員處理',
  meeting_agree: '已通過',
  remark_title: '備註（描述）',
  receipt_accept: '參加',
  receipt_no_accept: '不參加',
  receipt_back: '返回首頁',
  regional_maintenance_title: '會議室管理列表',
  new_regional_maintenance: '新增區域',
  regional_maintenance: '區域管理',
  regional_maintenance_edit_tip: '此操作將放棄修改，是否繼續？',
  regional_maintenance_edit_tip_placeholder: '請輸入1-50個字符',
  department_maintenance_title: '部門設置',
  new_department_maintenance: '新增部門',
  department_maintenance_edit_tip: '此操作將放棄修改，是否繼續？',
  department_maintenance_edit_tip_placeholder: '請輸入1-20個字符',
  need_audit: '需審核',
  need_sign: '需簽到',
  re_review: '待審核',
  zone_no_select: '沒有符合條件的結果',
  pls_check_zone: '請選擇區域',
  pls_check_dept: '請選擇所屬組織',
  pls_check_depart: '請選擇部門',
  pls_check_default_dept: '請選擇默認組織',
  pls_check_building: '請選擇樓宇',
  pls_select_device: '請選擇設備',
  group_name2: '名稱',
  service_type: '服務類型',
//應用管理
  application_management: '應用管理',
  upload_type: '類型',
  upload_NewVersion: '上傳新版本',
  version_list: '版本列表',
  version: '版本號',
  version_profile: '版本簡介',
  state: '狀態',
  open: '開啟',
  close: '關閉',
  upload_file: '上傳文件',
  meeting_border: '會議展板',
  meeting_booking: '會議預約',
  format_error: '文件格式只能為apk類型',
  version_format_error: '請輸入正確的版本號,格式為XXX.XXX.XXX(僅包含數字)',
  version_format: '版本簡介，描述不超過50個漢字',
  download_title: '下載',
  meeting_signage: '會議展板',
  download_text1:
    '會議展板支持Outlook/Exchange、Google、OA、手機APP等多種會議室預訂方式的消息推送及展示 ; 支持在展板上進行預訂、簽到、簽退、延時等交互性操作。',
  download_text2: '智能會議展板下載',
  download_text3: '會議預約APP下載',
  download_text4: '會議預約APP下載',
  download_text5: 'Andriod 下載',
  download_text6: 'IOS 下載',
  download_text7: 'Andriod 下載',
  no_download: '無可用版本下載，請聯繫管理員！',
  upload_info_prompt: '請完善上傳信息的必填項',
  re_reset: '重置',
  ex_status_link: '連接',
  ex_have_link: '已連接',
  ex_status_unlink: '斷開連接',
  ex_have_unlink: '已斷開',
  upload_success: '上傳成功',
  select_file: '選擇文件',
  loreal_check_in: '簽到',

// 報表
  report_report: '報表',
  report_search: '查詢',
  report_meeting: '會議室',
  report_percent: '百分比',
  report_detail: '詳情',
  report_meeting_title: '統計報表/會議室明細查詢',
  report_meeting_list_title: '統計報表/會議預約報表',
  report_meeting_release_title: '統計報表/會議釋放統計',
  report_room_occupy_title: '統計報表/會議室佔用情況',
  report_area: '區域',
  report_meeting_name: '會議室名稱',
  report_holder_name: '申請人',
  report_meeting_date: '會議日期',
  report_meeting_time: '會議時間',
  report_meeting_theme: '會議主題',
  report_room_name: '會議室名稱',
  report_pls_name: '請輸入會議室名稱',
  report_pls_name_f: '輸入多個會議室時請用;隔開',
  report_pls_holder_f: '請輸入申請人姓名',
  report_room_place_holder: '請選擇會議室',
  report_date: '日期',
  report_unit: '會議室*百分比',
  report_no: '序號',
  report_meeting_no: '會議數量',
  report_sign_num: '簽到次數',
  report_sign_time: '簽到時長',
  report_occupancy_time: '佔用時長',
  report_occupancy_rate: '佔用率',
  report_booking_rate: '預訂率',
  report_use_rate: '使用率',
  report_disuse_rate: '棄用率',
  report_occupancy_info: '會議室佔用情況',
  report_used_info: '會議室使用率詳情',
  report_booking_disuse_info: '會議室預訂次數與棄用次數對比',
  report_roomDetail_dayNum: '日期',
  report_roomDetail_bookNum: '預訂次數',
  report_roomDetail_cancelNum: '取消次數',
  report_roomDetail_earlyNum: '提前結束次數',
  report_roomDetail_delayNum: '延長次數',
  report_roomDetail_disuseNum: '棄用次數',
  report_roomDetail_unSignNum: '未簽到次數',
  report_roomDetail_unSignNames: '未簽到名單',
  report_roomDetail_num: '次數',
  report_roomDetail_title: '統計報表/會議室佔用率統計/會議室詳情',
  report_roomDetail_back: '返回',
  report_roomDetail_chart: '會議室使用次數與未簽到次數對比圖',
  report_roomDetail_detail: '會議室佔用率詳情',
  report_occupancy_detail: '會議室佔用情況一覽',
  report_room_occupy_popular: '會議室使用時段熱門指數',
  report_display: '顯示更多列',
  report_custom: '自定義報表',
  report_custom_add: '新建報表',
  report_custom_delete: '刪除',
  report_custom_view: '查看',
  report_custom_delete_confirm: '確認刪除該自定義報表模板？',
  report_custom_name: '報表名稱',
  report_custom_sql: 'SQL語句',
  report_custom_btn_excute: '執行SQL',
  report_custom_btn_save: '保存',
  report_custom_name_placeholder: '請輸入報表名稱',
  report_custom_sql_placeholder: '禁止的SQL關鍵字',
  report_custom_sql_null: '請輸入SQL腳本',
  report_custom_sql_keyword_invalid: '非法的SQL關鍵字',
  report_custom_sql_fenhao_forbidden: '請勿使用分號',
  report_custom_sql_querry_success: '查詢執行成功',
  report_custom_save_success: '報表保存成功',
  report_custom_delete_success: '報表刪除成功',
  report_abnormal_detail_page: '異常使用詳情',
  report_room_detail_page: '會議室詳情',

  report_abnormal_statis_report: '統計報表',
  report_abnormal_meeting_statis: '會議室數據統計',
  report_abnormal_meeting_detail: '會議室數據統計/使用詳情',
  report_abnormal_user_statis: '用戶預訂統計',
  report_abnormal_user_detail: '用戶預訂統計/使用詳情',
  report_abnormal_back: '返回',
  report_abnormal_normal: '正常',
  report_abnormal_cancel: '取消',
  report_abnormal_extend: '延時',
  report_abnormal_normal_f: '按時結束',
  report_abnormal_cancel_f: '棄用',
  report_abnormal_extend_f: '延時結束',
  report_abnormal_early_end: '提前結束',
  report_abnormal_cancel_num: '棄用({num}次)',
  report_abnormal_extend_num: '延時結束({num}次)',
  report_abnormal_early_end_num: '提前結束({num}次)',
  report_abnormal_normal_num: '按時結束({num}次)',
  report_abnormal_detail_dept: '部門',
  report_abnormal_detail_creater: '預訂人',
  report_abnormal_detail_meeting_name: '會議名稱',
  report_abnormal_detail_meeting_time: '會議時間',
  report_abnormal_detail_operate_time: '操作時間',

//report  user
  report_user_title: '統計報表/用戶預訂查詢',
  report_user: '預訂人',
  report_user_pls_name: '請輸入姓名',
  report_user_pls_name_f: '輸入多個姓名時用;隔開',
  report_user_dept: '部門',
  report_user_userDept: '部門',
  report_user_bookTimes: '預訂次數',
  report_user_time: '預訂時長',
  report_user_usage: '預訂使用率',
  report_download: '導出報表',
  report_time_length: '時長',

//service +
  service_room_img: '會議室圖片',
  service_sign_noneed: '不簽到',
  service_sign_password: '認證簽到',
  service_sign_Invitation: '邀請碼簽到',
  service_sign_qr: '二維碼簽到',
  service_sign_face: '人臉識別簽到',
  service_sign_anonymous: '匿名簽到',

  meeting_file: '附件',
  meeting_file_upload: '上傳附件',
  meeting_file_notice_0_size: '不能上傳大小為0kb的文件!',

  meeting_cal_meeting_infor: '會議信息',

  meeting_reserve_status_status0: '未開始',
  meeting_reserve_status_status1: '已開始',
  meeting_reserve_status_status2: '已結束',
  meeting_reserve_status_status3: '已取消',
  meeting_reserve_status_status4: '審核拒絕',
  meeting_reserve_status_status5: '待審核',
  meeting_reserve_status_status6: '歸檔',

  meeting_status_2: '會議已結束',
  meeting_status_3: '會議已取消',

  meeting_remind_message_mail_webex_reason: '該會議不存在',
  meeting_remind_message_mail_webex_reason_holder: '該會議未開始,請提前十分鐘進入',
  meeting_remind_message_mail_webex_reason0: '主持人未開啟會議，請等待',
  meeting_remind_message_mail_webex_reason1: '該會議正在進行',
  meeting_remind_message_mail_webex_reason2: '該會議已經結束',
  meeting_remind_message_mail_webex_reason3: '該會議已經取消',
  meeting_remind_message_mail_webex_reason4: '該會議審核未通過',
  meeting_remind_message_mail_webex_reason5: '該會議正在審核',
  meeting_remind_message_mail_webex_reason6: '該會議已經開啟',
  meeting_remind_message_mail_webex_reason7: '該會議暫未開始',
  meeting_remind_message_mail_webex_startWebex: '開啟 Webex 會議',
  meeting_remind_message_mail_webex_joinWebex: '加入會議',
  meeting_remind_message_mail_webex_startTel: '開啟 電話會議',
  meeting_reserve_message_mail_webex_name: '會議主題',
  meeting_reserve_message_mail_webex_rooms: '會議室',
  meeting_reserve_message_mail_webex_creator: '會議創建人',
  meeting_reserve_message_mail_webex_holder: '申請人',
  meeting_reserve_message_mail_webex_users: '會議參會人',
  meeting_reserve_message_mail_webex_startTime: '開始時間',
  meeting_reserve_message_mail_webex_endTime: '結束時間',
  meeting_reserve_message_mail_webex_remark: '備註(描述)',
  meeting_reserve_message_mail_webex_status: '會議狀態',

  meeting_detail_webex_email_empty: 'Webex參會人郵箱不能為空！',

  board_no_data: '無',

  door_access_notice_msg: '請通過二維碼掃描簽到開門',

  smartDevice_notice_url_empty: '智能設備地址不能為空',
  smartDevice_notice_key_empty: '智能設備key不能為空',
  access_notice_url_empty: '門禁服務地址不能為空',
  access_notice_key_empty: '門禁服務client id不能為空',
  smart_device_server: '智能設備服務',
  smart_device_server_open: '開啟智能設備服務',
  smart_device_placeholder_url: '服務地址',

  access_device_server: '門禁服務',
  access_device_server_open: '開啟門禁服務',
  smart_device_button_save: '保存',
  access_device_placeholder_door_code:
    '輸入多個門號時，門號之間請用英文","分隔',

  device_light: '智能燈',
  device_outlet: '智能插座',
  device_curtain: '智能窗帘',
  access_no: '門禁編號',

  smart_device_closed: '智能設備服務已關閉',
  access_device_closed: '門禁服務已關閉',

  smart_device_drop_down_no_data: '暫無數據',

  device_submit: '確定',
  device_fixed_title: '固定設備',
  device_fixed_name_label: '固定設備名稱',
  device_fixed_num_label: '固定設備編號',
  device_fixed_name_empty: '請輸入固定設備名稱,建議加上設備型號',
  device_fixed_num_empty: '請輸入固定設備編號:如:G-TV-01',
  device_mobile_title: '移動設備',
  device_mobile_name_label: '移動設備名稱',
  device_mobile_nums_label: '移動設備數量',
  device_mobile_name_empty: '請輸入移動設備名稱',
  device_num_not_null: '設備編號不能為空',
  device_nums_not_null: '設備數量不能為空',
  device_name_not_null: '設備名稱不能為空',
  service_device_select: '固定設備列表',
  service_device_selected: '已選擇的固定設備',

  attend_select_amount: '已選擇 {value} 人',
  attend_delete_user: '確認要刪除用戶{value}?',

  monitor_panel: '展板監控',
  monitor_panel_meeting_room: '會議室',
  monitor_panel_status: '狀態',
  monitor_panel_search: '查詢',
  monitor_panel_result: '查詢結果：共 {value} 塊展板異常',
  monitor_panel_area: '區域選擇',
  monitor_panel_room_name: '會議室名稱',
  monitor_panel_position: '展板位置描述',
  monitor_panel_operation: '操作',
  monitor_panel_repair: '修復異常',
  monitor_panel_delete: '刪除監控',
  monitor_panel_status_all: '全部',
  monitor_panel_status_normal: '正常',
  monitor_panel_status_apperror: 'APP異常',
  monitor_panel_status_h5error: '頁面異常',
  monitor_panel_more: '更多',
  monitor_panel_repair_APP: '重啟APP',
  monitor_panel_repair_H5: '刷新界面',
  monitor_panel_repair_restart: '重啟展板',
  monitor_panel_refresh_all: '全部刷新',
  monitor_panel_refresh_warning: '您確定要刷新嗎？',

  monitor_alarm_set: '告警設置',
  monitor_alarm_frequency: '告警次數設置',
  monitor_alarm_every_set: '每次異常都告警',
  monitor_alarm_follow_set: '按照設置進行告警',
  monitor_alarm_every: '每',
  monitor_alarm_minutes: '分鐘',
  monitor_alarm_times: '次異常進行告警',
  monitor_alarm_mailbox: '告警接收人郵箱',
  monitor_time: '監控時間段',
  monitor_alarm_input_rule: '輸入多個郵箱時用 ; 隔開',
  monitor_alarm_apply: '應用',
  monitor_alarm_intervalTime_error: '請填寫告警間隔時間！',
  monitor_alarm_frequency_error: '請填寫告警次數！',
  monitor_alarm_email_error: '請填寫正確郵箱格式！',

  application_size_lt_100: '應用文件大小不能超過100Mb',

  fault_yesterday_fault_statistics: '昨日故障統計',
  fault_7_fault_statistics: '7日故障統計',
  fault_fault_statistics: '故障統計',
  fault_7_fault_number: '7日故障數',
  fault_top5: '故障展板TOP5',
  fault_number_of_failures: '故障數',
  fault_failures_rate: '故障率',
  fault_times: '次',
  fault_select_time: '選擇時間段',
  fault_select_time_placeholder: '請選擇時間',
  fault_search_button: '查詢',
  fault_number_of_failures_title: '故障次數',
  fault_time_error: '開始時間不能大於結束時間',
  fault_zone_error: '請選擇區域後查詢',

//頭像上傳頁面
  face_header_h4: '信息錄入',
  face_header_p1: '您好',
  face_header_p2: '您有一些信息需要提交',
  face_body_name: '姓名：',
  face_body_dept: '部門：',
  face_body_face: '上傳人臉識別照片：',
  face_body_select: '選擇照片',
  face_body_submit: '提交',
  face_body_tip: '祝您工作愉快。',
  face_footer_tip1: '海銀金融控股集團有限公司',
  face_footer_tip2: '聯繫電話：+86(21)8013 3999',

//地圖信息頁面
  map_header_h4: '地圖信息',
  map_header_p1: '您好',
  map_body_room: '會議室：',
  map_body_daoyin: '地圖導引：',

  service_cleaning_manage_title: '保潔人員管理',
  service_back_to_service_manage_title: '返回服務管理',
  service_add_cleaning_manage_title: '添加保潔人員',
  service_new_level: '新增等級',
  service_new_item: '新增服務項',
  service_edit_item: '編輯服務項',
  service_item_manage: '服務項管理',
  service_level: '服務等級',
  service_item: '服務項',
  service_item_item: '服務項目',
  service_item_name: '服務名稱',
  service_item_price: '單價',
  service_item_unit: '單位',
  service_item_type: '類別',
  service_item_select: '選擇服務項',
  service_item_if_number: '是否數量',
  service_item_if_remark: '是否備註',
  yes: '是',
  no: '否',
  service_item_price_format: '格式：0.00',
  service_need_number: '是否需要數量',
  service_need_number_explain: '註：關閉後用戶無需輸入服務項的數量',
  service_need_remark: '是否需要備註',
  service_need_remark_explain: '註：關閉後用戶無需輸入備註信息',
  service_need_describe_explain:
    '該信息顯示在用戶端，打開開關為提示備註信息的說明輸入框;關閉開關為顯示文本信息',
  service_delete_data: '確定要刪除該條數據嗎？',
  service_level_error: '請填寫服務等級名稱！',
  service_level_same: '服務等級名稱不能相同！',
  service_svcIds_error: '請至少選擇一個服務項！',
  service_item_error: '請填寫服務名稱！',
  service_price_error: '請填寫服務單價！',
  service_unit_error: '請填寫服務單位！',
  service_type_error: '請選擇服務類別！',
  service_remark_error: '請填寫備註信息！',

  audit_reject_reason: '拒絕理由',
  audit_reject_reason_pre: '拒絕理由：',
  audit_reject_tip: '請輸入拒絕理由',
  audit_svc_detail: '會議服務詳情',
  audit_svc_audit: '會議服務審批',
  audit_svc_no_need_audit: '無需審批',
  audit_reject_tip_title: '審批信息：',

//系統個性化設置
  per_a_1: '系統LOGO',
  per_a_2: '上傳中文logo',
  per_a_3: '上傳英文logo',
  per_a_4: '推薦上傳200*600像素，照片格式可以為jpeg / jpg / png, 大小不超過2M',
  per_a_5: '會議展板LOGO及背景',
  per_a_6: '推薦上傳350*100像素，照片格式可以為jpeg / jpg / png, 大小不超過2M',
  per_a_7: '背景',
  per_a_8:
    '推薦上傳1280*800像素，照片格式可以為jpeg / jpg / png, 大小不超過10M',
  per_a_9: '短訊簽名',
  domain_sms_sign_hint: '短訊簽名不能為空，且需提前在短訊平台申請',
  per_a_10: '保存',
  per_a_11: '郵件表頭',
  per_a_12: '上傳郵件表頭',
  per_a_13:
    '推薦上傳600*100像素，照片格式可以為jpeg / jpg / png, 大小不超過300K',
  per_a_14: '用戶初始化密碼設置',
  per_user_pwd_not_empty: '用戶初始化密碼不能為空！',
  per_a_15: '初始密碼',
  per_a_16: '系統名稱',
  per_a_17: '系統中文名稱',
  per_a_18: '系統英文名稱',
  per_b_1: '圖片上傳失敗',
  per_b_2: '確認',
  per_b_3: '請選擇正確的圖片格式文件',
  per_b_4: '圖片文件過大',
  per_b_5: '保存成功!',

//模板管理
  boardman_1_0: '模板管理',
  boardman_2_0: '節能設置',
  boardman_2_1: '模式:',
  boardman_2_2: '禁用',
  boardman_2_3: '周期模式（每天）',
  boardman_2_4: '工作日模式（節假日關機）',
  boardman_2_5: '開機時間:',
  boardman_2_6: '關機時間:',
  boardman_2_7: '開機時間必須早於關機時間!',
  boardman_2_8: '保存',
  boardman_3_0: '版本更新',

  meeting_placeholder_start_date: '請選擇開始日期',
  meeting_placeholder_end_date: '請選擇結束日期',
  meeting_placeholder_name_id: '請輸入會議主題或ID',
  meeting_placeholder_room: '請選擇會議室',
  meeting_placeholder_remark: '請輸入會議備註',
  meeting_btn_create_normal_meeting: '新建普通會議',
  meeting_btn_create_video_meeting: '新建視頻會議',
  meeting_btn_mine_book: '我預約',
  meeting_btn_mine_attend: '我參會',
  meeting_btn_mine_manage: '我管理',
  meeting_list_header_status: '會議狀態',
  meeting_list_header_convene: '會議所屬',
  meeting_list_header_advanced_search: '高級搜索',
  meeting_list_table_id: '會議ID',
  meeting_list_table_subject: '會議主題',
  meeting_list_table_status: '狀態',
  meeting_list_table_room: '會議室',
  meeting_list_table_start: '開始時間',
  meeting_list_table_end: '結束時間',
  meeting_list_table_creator: '申請人',
  meeting_list_table_operate: '操作',
  meeting_list_operate_cancelText: '是否取消此會議?',
  meeting_list_operate_stopText: '是否結束此會議?',
  meeting_list_operate_book_again: '再次預訂',
  meeting_cancel_cmma_title: '視頻會議仍在進行',
  meeting_cancel_cmma_text: '請在會控頁面結束視頻會議',

  cleaning_manage_name: '姓名',
  cleaning_manage_phone: '手機',
  cleaning_manage_email: '郵箱',
  cleaning_manage_list: '保潔人員管理',
  cleaning_manage_operate: '操作',
  role_manage_role_name: '角色名稱',
  role_manage_permission: '權限分配',
  role_manage_operate: '操作',
  role_manage_user_list: '用戶列表',
  role_manage_edit: '編輯',
  role_manage_delete: '刪除',
  role_manage_delete_confirm: '確定要刪除該角色嗎？',
  role_manage_edit_role: '編輯角色',
  role_manage_all: '全部',
  role_manage_emp_name: '員工姓名',
  role_manage_time: '指定時間',
  role_manage_delete_user_role: '確定要刪除該用戶的角色嗎？',
  role_manage_delete_user_role_fail1: '該用戶已分配會議室，請先解除，再刪除',
  role_manage_add_user_success: '用戶添加成功！',
  role_manage_add_user_pls: '請選擇要添加的用戶！',
  role_manage_cant_del_your_self: '禁止刪除當前用戶的角色',

  user_add_sub_dept: '新增子部門',
  user_add_comp_dept: '新增子公司、子部門',
  main_btn_reset_pwd: '密碼重置',
  main_search_keywords: '請輸入搜索關鍵詞',
  meeting_dept_user_add: '新增用戶',
  meeting_dept_user_edit: '編輯用戶',
  meeting_dept_user_import: 'Excel導入',
  meeting_dept_delete_confirm: '確定刪除?',
  meeting_user_delete_confirm: '確定要刪除該用戶嗎?',
  meeting_pwd_reset_confirm: '確定要重置該用戶的密碼嗎?',
  meeting_dept_user_import_success: '導入成功',
  meeting_dept_user_file_failed: '文件上傳失敗',

  notice_manage_global_config: '全局通知配置',
  notice_manage_global_config_content: '預約會議成功後，默認所有參會人使用以下方式接收通知。',
  notice_manage_user_notice_config: '用戶通知配置',
  notice_manage_user_notice_config_content: '預約會議時，預訂人可選擇接收通知的方式。',
  system_manage_meeting_admin_success: '設置會議室管理員成功',
  system_manage_delay_time_config: '會議延長配置',
  system_manage_delay_time_config_content: '設置會議延長的時間，設置PC端、展板端默認缺省延長的時長。',
  system_manage_delay_time_config_success: '會議延長配置保存成功',
  system_manage_delay_time_config_fail: '會議延長配置保存失敗',
  system_manage_delay_time: '延長時長',
  system_manage_delay_time_desc: '分鐘 （註：以"|"進行分割，最多不超過3個）',

  system_manage_infrared_check_time_title: '紅外會議室無人檢測時間',
  system_manage_infrared_check_time_desc: '會議進行中時，若紅外會議室持續一段時間無人，會釋放會議，或發送提醒郵件',
  system_manage_infrared_check_time_pre: '持續無人檢測時間：',
  system_manage_infrared_check_time_warn: '請輸入正確的無人檢測時間！',
  system_manage_board_useing: '使用中',
  system_manage_board_error: '異常',
  system_manage_board_stop: '已停用',
  system_manage_board_start: '啟用',

  notice_manage_sms: '短訊',
  notice_manage_email: '郵件',
  notice_manage_vsk: '威思客',
  notice_manage_wechat: '微信',
  notice_manage_dd: '釘釘',
  work_day_label_select_year: '選擇年份',
  work_day_label_working_hours: '工作時間',
  work_day_label_working_day: '工作日',
  work_day_label_Holiday: '節假日',
  work_day_setting: '設置',
  Monday: '周一',
  Tuesday: '周二',
  Wednesday: '周三',
  Thursday: '周四',
  Friday: '周五',
  Saturday: '周六',
  Sunday: '周日',
  work_day_btn_save: '保存',
  work_day_warning_work_hour: '請選擇正確的工作時間！',
  work_day_working_day: '請選擇工作日',
  work_day_remind: '是否將{date} {value}設為{holiday}?',

  log_manage: '日誌管理',
  log_manage_placeholder_operate_type: '請選擇操作類型',
  log_manage_placeholder_operator_id: '請輸入操作者ID',
  log_manage_btn_query: '查詢',
  log_manage_btn_reset: '重置',
  log_manage_operate_time: '操作時間',
  log_manage_operator: '操作人',
  log_manage_operate_type: '操作類型',
  log_manage_log_info: '日誌詳情',

  port_manage_protocol: '協議',
  port_manage_version: '版本',
  port_manage_ip: '地址',
  port_manage_account: '賬號',
  port_manage_password: '密碼',
  port_manage_describe: '描述',
  port_manage_btn_save: '保存',
  port_manage_btn_connect: '連接',
  port_manage_btn_disconnect: '斷開連接',

  device_manage_add_mobile: '新增移動設備',
  device_manage_edit_mobile: '修改移動設備',
  device_manage_add_stable: '新增固定設備',
  device_manage_edit_stable: '修改固定設備',
  device_manage_back: '返回設備管理',
  device_manage_device_name: '設備名稱',
  device_manage_device_name_cn: '設備中文名稱',
  device_manage_device_name_en: '設備英文名稱',
  device_manage_device_describe: '描述',
  device_manage_device_number: '數量',
  device_manage_floor: '所屬區域',
  device_manage_cancel: '取消',
  device_manage_ok: '確定',
  device_manage_warning_empty_name: '設備名稱不能為空！',
  device_manage_warning_empty_name_cn: '設備中文名稱不能為空！',
  device_manage_warning_empty_name_en: '設備英文名稱不能為空！',
  device_manage_warning_empty_number: '數量不能為空！',
  device_manage_warning_empty_floor: '樓層不能為空！',
  device_manage_operate: '操作',
  device_manage_edit: '編輯',
  device_manage_delete: '刪除',
  device_manage_confirm_delete: '確定要刪除該條數據嗎？',
  device_manage_borrow_manage: '借用管理',
  device_manage_stable_manage: '固定設備管理',
  device_manage_mobile_manage: '移動設備管理',
  device_manage: '設備管理',
  device_manage_meeting_time: '會議時間',
  device_manage_meeting_title: '會議主題',
  device_manage_meeting_room: '會議室',
  device_manage_meeting_applier: '申請人',
  device_manage_meeting_device: '申請設備',
  device_manage_number: '數量',
  device_manage_lend_state: '借用狀態',
  device_manage_warning_edit_success: '修改成功！',
  device_manage_warning_save_success: '保存成功！',
  device_manage_warning_delete_success: '刪除設備成功！',
  device_manage_area: '區域',
  device_manage_lend: '借用',
  device_manage_give_back: '歸還',
  device_manage_confirm_occupied: '該設備已被下列會議室佔用：',
  device_manage_confirm_cannot_delete: '不允許刪除！',
  device_manage_confirm_if_update: '是否仍要修改？',

  device_manage_state_lend_able: '可借用',
  device_manage_state_lending: '借用中',
  device_manage_state_give_back: '已歸還',

  support_manage_front_empty: '暫無',
  support_manage_list: '會議支持列表',
  support_manage_receptionist_number: '前台號碼',
  support_manage_name: '會議支持名稱',
  support_manage_operate: '操作',
  support_manage_btn_add: '新增',
  support_manage_receptionist_edit: '編輯',
  support_manage_oprate_edit: '編輯',
  support_manage_oprate_delete: '刪除',
  support_manage_edit_title: '編輯會議支持',
  support_manage_edit_ok: '確認',
  support_manage_edit_cancel: '取消',
  support_manage_edit_name: '會議支持名稱',
  support_manage_edit_duplicate_name: '會議支持名稱重複！',
  support_manage_edit_empty_name: '會議支持名稱不能為空！',
  support_manage_delete_msg: '確定要刪除該項會議支持嗎？',

  service_need_upload_attachments: '是否上傳附件',
  service_need_upload_attachments_attention: '注: 關閉後用戶無法上傳附件',
  service_need_approve: '是否需要審批',

  modal_manage_name: '模板名稱',
  modal_manage_bind_meeting_name: '綁定會議室',
  modal_manage_operate: '操作',
  modal_manage_edit: '編輯',
  modal_manage_delete: '刪除',
  modal_manage_add: '新增',

  modal_manage_version_title: '展板版本更新',
  modal_manage_version_name: '名稱',
  modal_manage_version_name_placeholder: '請上傳文件',
  modal_manage_version: '版本號',
  modal_manage_version_placeholder: '請輸入版本號',
  modal_manage_version_create_user: '創建人',
  modal_manage_version_create_time: '創建時間',
  modal_manage_version_url: '下載地址',
  modal_manage_version_desc: '更新描述',
  modal_manage_version_status: '狀態',
  modal_manage_version_file: 'Apk文件',
  modal_manage_version_desc_placeholder: '請輸入更新描述',

  modal_manage_edit_title: '模板設置',
  modal_manage_edit_version_title: '上傳安裝包',
  modal_manage_btn_ok: '確認',
  modal_manage_btn_cancel: '取消',
  modal_manage_btn_end: '提前結束',
  modal_manage_edit_template_name: '模板名稱',
  modal_manage_edit_template_name_placeholder: '請輸入模板名稱',
  modal_manage_edit_uploadlogo: '上傳中文LOGO',
  modal_manage_edit_uploadlogo_hint:
    '圖片格式可以為jpeg / jpg / png, 大小不超過500K',
  modal_manage_edit_eng_uploadlogo: '上傳英文LOGO',
  modal_manage_edit_eng_uploadlogo_hint:
    '圖片格式可以為jpeg / jpg / png, 大小不超過500K',
  modal_manage_edit_bg: '選擇展板背景',
  modal_manage_edit_bg_hint:
    '要求上傳尺寸為1280*768像素, 照片格式可以為jpeg / jpg / png, 大小不超過2M',
  modal_manage_meeting_room: '會議室',
  modal_manage_meeting_room_Occupy:
    '有會議室正在使用此模板，刪除後將切換成默認模板',
  modal_manage_no_bg: '請上傳展板背景',
  modal_manage_no_eng_logo: '請上傳英文LOGO圖片',
  modal_manage_no_logo: '請上傳中文LOGO圖片',
  modal_manage_no_template_name: '模板名稱不能為空',
  board_manage_big_image: '圖片文件過大',
  board_manage_has_apk: '已經存在文件',
  board_manage_big_apk: 'Apk文件過大',
  board_manage_error_image_format: '請選擇正確的圖片格式文件',
  board_manage_error_apk_format: '請上傳apk文件',
  modal_manage_board_version_occupy: '是否啟用此展板版本',

  upload_img_tip:
    '推薦上傳尺寸為{w}*{h}像素，照片格式可以為jpeg/jpg/png/bmp，大小不超過{n}M',
  upload_img_isLt: '圖片大小不能超過{n}M',

  room_manage_list_name: '會議室名稱',
  room_manage_list_zoneFullName: '會議室區域',
  room_manage_list_adminUserName: '管理員',
  room_manage_list_qr: '二維碼',
  room_manage_list_qr_title: '查看二維碼',

  room_manage_list_oprate: '操作',

  room_manage_repair: '會議室維護',
  room_manage_list_visible: '啟用狀態',
  room_manage_device_repair: '設備維護',
  room_manage_no_device_repair: '該會議室沒有需要維護的設備',

  room_manage_delete_msg: '是否刪除此會議室？',
  room_manage_video_bind: '視頻設備綁定',
  room_manage_video_bind_suc: '視頻設備綁定成功！',
  room_manage_video_bind_fail: '視頻設備綁定失敗！',
  room_manage_video_delete_ok: '視頻設備刪除成功',
  room_manage_video_delete_fail: '視頻設備刪除失敗',

  room_manage_add_meeting_room: '添加會議室',
  room_manage_Enable_meeting_room: '批量下線',
  room_manage_offline_msg: '是否批量下線該會議室?',
  room_manage_offRoomSelect_msg: '請至少選擇一條數據?',
  room_manage_choose_meetingroom_admin: '請選擇會議室管理員',
  room_manage_bind: '綁定',

  roomqr_manage: '查看二維碼',
  roomqr_manage_close: '關閉',
  roomqr_manage_download: '下載',
  room_device_repair_title: '設備維護',

  room_device_fault: '故障',
  room_device_normal: '正常',
  room_manage_list: '會議室管理列表',

  room_add_modal_title: '新增會議室',
  room_edit_modal_title: '修改會議室',
  room_edit_room_name: '會議室名稱',
  room_edit_room_nameEn: '會議室英文名稱',
  room_edit_room_code: '會議室門號',
  room_edit_belong_area: '所屬區域',
  room_edit_area: '區域',
  room_edit_floor: '樓層',
  room_edit_email: '郵箱',
  room_edit_people_number: '人數',
  room_edit_person: '人',
  room_edit_cost: '會議室使用費用',
  room_edit_unit_price: '元 / 小時',
  room_edit_room_type: '會議室類型',
  room_edit_placeholder_room_type: '請選擇會議室類型',
  room_edit_allow_apply_svc: '允許申請會議服務',
  room_manage_organization: '所屬組織',
  room_edit_sign_type: '簽到類型',
  room_edit_placeholder_sign_type: '請選擇簽到類型',
  room_edit_need_audit: '是否需要審批',
  room_edit_usage: '是否啟用',
  room_edit_room_manage: '會議室管理員',
  room_edit_fixed_device: '固定設備',
  room_edit_placeholder_fixed_device: '請選擇固定設備',
  room_edit_room_image: '會議室圖片',
  room_edit_room_order: '會議室排序序號',
  room_edit_placeholder_room_order: '請輸入會議室排序號',
  room_edit_open_hw: '是否打開紅外',
  room_edit_cancel: '取消',
  room_edit_ok: '確定',
  room_edit_admin_warning: '會議室管理員必須包含您自己！',
  room_edit_wrong_num: '會議室最大人數不能小於最小人數！',
  room_edit_device_maximum: '會議室固定設備不能多於5個',

  region_confirm_delete_record: '您確認刪除這條記錄嗎？',
  report_placeholder_meeting_room: '請選擇會議室',

  meeting_detail_start_now: '立即開始',

  meeting_tab_meeting_info: '會議信息',
  meeting_tab_meeting_service_apply: '會議服務申請',
  meeting_tab_meeting_sign: '簽到管理',
  meeting_tab_meeting_agenda: '會議議程',
  meeting_tab_meeting_device_lend: '移動設備借用',

  meeting_device_add: '添加移動設備',
  meeting_device_search: '請輸入設備名稱搜索',
  meeting_device_type: '設備類型',

  meeting_info_initiate_auto: '自動發起',
  meeting_info_reconnect_auto: '自動重連',
  meeting_info_cospaces: '會議號',

  room_detail_room_type: '會議室類型',

  policy_manage_meeting_lock_time: '配置鎖定時間',
  policy_manage_meeting_lock_time_content:
    '會議結束後,設置鎖定一段時間再進行下一場會議',
  policy_manage_btn_save: '保存',
  policy_manage_meeting_willend_time: '會議結束提醒',
  policy_manage_meeting_willend_time_content: '會議結束前發送提醒通知的時間',

  policy_manage_meeting_remind_time: '會前提醒時間',
  policy_manage_meeting_remind_time_content: '會前發送提醒通知的時間',
  policy_manage_before_meeting_start: '會議開始前',

  policy_manage_unrepresented_reminder: '未參會人提醒',
  policy_manage_unrepresented_reminder_content:
    '給未參會人的人發送通知，配置會議展板上「提醒」按鈕顯示和隱藏的時間',
  policy_manage_meeting_check_in_time: '會議簽到時間',
  policy_manage_meeting_check_in_time_content: '設置會議默認簽到時間',
  policy_manage_meeting_lock: '一鍵鎖定會議',
  policy_manage_meeting_lock_content: '鎖定會議，紅外無法釋放會議',
  policy_manage_room_maintain: '一鍵維護會議室',
  policy_manage_room_maintain_content: '會議室維護中，不允許預約',
  policy_manage_display_board_btn_switch: '展板按鈕開關',
  policy_manage_webex_btn_switch: 'WebEx會議設置',
  policy_manage_webex_btn_content: 'WebEx會議預約界面的設置',
  policy_manage_meeting_function_btn_switch: '會議功能開關',
  policy_manage_display_board_btn_content:
    '展板「預約」和「延長」、「結束」按鈕和二維碼是否顯示的開關',
  policy_manage_meeting_function_btn_content:
    '關閉開關後，以下功能將不在預約流程中顯示',
  policy_manage_meeting_cleaner_btn_switch: '保潔通知開關',
  policy_manage_meeting_cleaner_btn_content:
    '是否需要會議結束後給保潔員發送通知提醒',
  policy_manage_if_lock: '是否鎖定',
  policy_manage_if_show: '是否顯示',
  policy_manage_if_notice: '是否提醒',
  policy_manage_sign_time_label: '會議開始前/後',
  policy_manage_time: '時間',
  policy_manage_before_meeting: '會議開始前',
  policy_manage_after_meeting: '會議開始後',
  policy_manage_before_meeting_end: '會議結束前',
  policy_manage_minute: '分鐘',
  policy_manage_day: '天',
  policy_manage_meeting_sign: '簽到管理',
  policy_manage_meeting_svc: '會議服務',
  policy_manage_meeting_device: '移動設備',
  policy_manage_meeting_agenda: '會議議程',
  sign_meeting_befer_or_after: '會議開始前/後',
  need_room_admin_audit: '在該會議室預約會議需要會議室管理員審批',
  external_contacts: '外部聯繫人',
  imcomplete_external_info: '外部聯繫人信息不完整！',

  meeting_service_apply_title: '會議服務申請',
  meeting_service_apply_btn: '申請',
  meeting_service_apply_column_select: '選擇',
  meeting_service_apply_column_service_type: '服務類型',
  meeting_service_apply_column_price: '單價',
  meeting_service_apply_column_number: '數量',
  meeting_service_apply_column_total: '小計(元)',
  meeting_service_apply_column_remark: '備註',
  meeting_service_apply_column_file: '附件',
  meeting_service_apply_label_total: '總計',
  meeting_service_apply_label_yuan: '元',

  meeting_apply_success: '申請成功!',
  meeting_save_success: '保存成功!',
  meeting_save_failed: '操作失敗!',
  meeting_book_success: '預約成功!',
  meeting_cmma_number: '會議號',
  meeting_cmma_password: '會議密碼',
  meeting_cancel_success: '會議取消成功!',
  meeting_send_msg: '發送通知',
  meeting_attends_inner: '內部參會人',
  meeting_attends_outer: '外部參會人',
  meeting_book_column_invite: '訪問邀約',
  meeting_book_jurisdiction_fail: '您沒有該會議室預訂權限，請聯繫管理員!',

  personal_common_addr: '常用地：',
  personal_addr_config: '個人常用地址配置',

  app_index_conf_name: '功能名稱',

  app_index_conf_cancel_show: '取消首頁顯示',
  app_index_conf_set_show: '設置首頁顯示',
  app_index_book: '預約會議',
  app_index_about: '關於',
  app_index_video_meeting: '視頻會議',
  app_index_my_meeting: '我的會議',
  app_index_initiate: '發起會議',
  app_index_webex_meeting: 'WebEx會議',
  user_edit_cardNo: '門禁卡號',
  meeting_list_sign_state: '簽到狀態',
  meeting_list_table_not_sign: '未簽到',
  meeting_list_table_sign: '已簽到',

  room_maintain_start_label: '開始時間',
  room_maintain_end_label: '結束時間',
  room_maintain_start_pls: '請選擇開始時間',
  room_maintain_end_pls: '請選擇結束時間',
  room_maintain_start_empty: '開始時間不能為空',
  room_maintain_end_empty: '結束時間不能為空',
  room_maintain_status_normal: '正常',
  room_maintain_status_valid: '維護中',
  room_maintain_start_less_than_now: '開始時間不能小於當前時間',
  room_maintain_end_less_than_start: '結束時間不能小於開始時間',

  meeting_sign_btn_export: '導出',
  meeting_sign_label_sign_state: '狀態',
  meeting_sign_label_has_sign: '已簽到',
  meeting_sign_label_no_sign: '未簽到',
  meeting_sign_label_sign_type: '方式',
  meeting_sign_label_sign_time: '時間',
  meeting_sing_label_unit_people: '人',
  meeting_sing_column_name: '姓名',
  meeting_sing_column_sign_time: '簽到時間',
  meeting_sing_column_sign_type: '簽到方式',
  meeting_sing_column_sign_img: '頭像',
  meeting_sing_column_sign_operation: '操作',
  meeting_sign_column_resign: '補簽',

  meeting_sing_type_none: '未簽到',
  meeting_sing_type_pwd: '密碼簽到',
  meeting_sing_type_qr_code: '掃碼簽到',
  meeting_sing_type_face: '人臉識別簽到',
  meeting_sing_type_infrared: '紅外簽到',
  meeting_sing_type_supplement: '預定人補簽',
  meeting_sing_type_anonymous: '匿名簽到',
  meeting_sing_type_door_access: '門禁簽到',

  mt_rls_kind_cancel: '取消',
  mt_rls_kind_normal: '結束',
  mt_rls_kind_unsigned: '未簽到釋放',
  mt_rls_type_cancel: '主動取消',
  mt_rls_type_unsigned: '未簽到',
  mt_rls_type_early: '提前結束',
  mt_rls_type_infrared: '紅外釋放',
  mt_rls_type_time_up: '正常結束',
  mt_rls_type_delay: '有延長',
  mt_rls_type_reject: '未批准',
  mt_rls_type_third_syn: '第三方同步',
  mt_rls_type_all_refused: '全部拒絕',
  mt_rls_type_room_maintain: '會議室維護',
  mt_rls_type_room_visible: '會議室不可用',
  license_title: 'license配置',
  license_subtitle: '配置系統license',
  license_label: 'license：',

  sys_log_server_select: '服務選擇',
  sys_log_search_date: '日期',
  sys_log_level: '日誌級別',
  sys_log_download: '下載',
  sys_log_search_date_empty: '請選擇日期',

  meeting_save_tips_subject: '主題',
  meeting_save_tips_holder: '申請人',
  meeting_save_tips_time: '時間',
  meeting_save_tips_reason: '原因',
  meeting_save_tips_lock_time: '鎖定時間',
  meeting_save_tips_reason_0: '時間段被其他會議佔用',
  meeting_save_tips_reason_1: '與其他會議鎖定時間衝突',
  meeting_save_tips_reason_2: '該會議鎖定時間被佔用',
  meeting_save_tips_reason_3: '主持人已預約該時間段會議',
  meeting_tips_room_maintain: '會議室維護',
  meeting_tips_holiday: '節假日',

  meeting_save_tips_yes: '是',
  meeting_save_tips_no: '否',

  meeting_save_tips_modal_title1: '以下時間段預約失敗,是否跳過並繼續預訂？',
  meeting_save_tips_modal_title2: '以下時間段預約失敗，無可預約會議！',
  meeting_sign: '會議簽到',
  sign_manage_need_attend: '需參會',
  sign_manage_unit_people: '人',
  sign_manage_sign: '簽到',
  sign_manage_not_sign: '未簽到',
  sign_manage_sign_state: '簽到狀態',
  sign_manage_sign_time: '簽到時間',
  sign_manage_sign_operation: '操作',
  sign_manage_resign: '補簽',
  sign_manage_status_has_sign: '已簽到',
  sign_manage_img: '頭像',
  sign_meeting_check_in_time: '簽到時間',

  delay_meeting_sub_title: '請選擇延長會議時間',
  delay_meeting_select_time: '{time}分鐘',
  delay_meeting_wish_tip: '祝您工作愉快！',
  delay_meeting_bottom_wafer: '威發系統有限公司',
  delay_meeting_loop_recurrence: '會議周期',

  room_name_comm: '常用會議室',
  message_agenda_value1: '主題，時間，演講人不能全部為空!',
  message_broadcast_value1: '直錄播申請成功!',
  message_send_msg_success: '發送通知成功',
  message_send_msg_fail: '發送通知失敗',

  meeting_agenda_speaker: '演講人',

// 會議服務
  meeting_services_info_value1: '請勾選需要的服務項！',
  meeting_services_info_value2: '已選擇會議服務數量不能為空或為0!',
  meeting_services_info_value3: '已選擇會議服務備註不能為空！',
  meeting_services_info_value4: '已選擇會議服務需上傳附件!',
  meeting_services_info_value5: '請選擇移動設備',
  meeting_services_info_value6: '打開Exchange連接操作成功',
  meeting_services_info_value7: '更新狀態成功',
  meeting_services_info_value8: '新增保潔人員',
  meeting_services_info_value9: '該服務需要會議服務管理員進行審批。',

  meeting_audit_fail_title: '審批失敗！',

  user_check_user_id_info: '請填寫用戶ID！',
  user_check_user_name_info: '請填寫姓名！',
  user_check_user_name_dep: '請選擇部門！',

  room_editor_check_okText: '確認',
  room_editor_check_name: '會議室名稱不能為空!',
  room_editor_check_nameEn: '會議室英文名稱不能為空!',
  room_editor_check_ord_min: '會議室排序序號只能是整數且不小於1！',
  room_editor_check_ord_max: '會議室排序序號不能超過6位！',
  room_editor_check_zone: '所屬區域不能為空!',
  room_editor_check_email: '郵箱不能為空!',
  room_editor_check_emailReg: '郵箱格式不正確!',
  room_editor_check_maxNumber: '會議室最大人數不能為空!',
  room_editor_check_minNumber: '會議室最大人數不能小於最小人數!',
  room_editor_check_adminUserId: '會議室管理員不能為空!',

  meeting_service_current_status: '當前狀態為：',
  continue_book: '確認',
  cancel_book: '取消',
  cancel_apply: '取消申請',
  continue_apply: '繼續申請',
  meeting_fee_notice: '預訂會議金額',
  meeting_room_single_price: '會議室單價：',
  room_fee_unit_hour: '小時',
  room_fee_unit_minute: '分鐘',
  room_fee_book_time: '預約時間：',
  room_fee_total: '會議室費用：',
  room_fee_during_time: '會議時長：',
  meeting_svc_fee_total: '會議服務費用：',
  meeting_fee_total: '總計：',
  notice_manage_label_billing: '是否計費',
  notice_manage_billing_titile: '預訂會議室計費',
  notice_manage_billing_config_content: '預定會議時，會議室是否需要計費',
  yuan_every_hour: '元/小時',

  cross_days_meeting_days_limit: '預約會議天數不能小於 {num} 天！',
  notice_manage_title_crossday_meeting_min_day: '長期會議最小天數',
  notice_manage_subtitle_crossday_meeting_min_day: '預約長期會議時的最小天數差',
  notice_manage_label_crossday_meeting_min_day: '天數：',
  unit_day: '天',
  long_term_meeting_label: '長期會議：',

  meeting_list_selected_meeting_desc: '已選擇 {num} 條數據',
  meeting_manage_batchCancel_meeting_msg: '確定取消該會議?',
  room_manage__meeting_batchCancel: '批量取消',

  meeting_bill_report: '統計報表',
  meeting_bill_report_time: '會議時間 :',
  meeting_bill_report_dept: '部門 :',
  meeting_bill_report_search: '查詢',
  meeting_bill_report_reset: '重置',
  meeting_bill_report_return: '返回',
  meeting_bill_report_export: '導出',
  meeting_bill_report_dept_user: '部門/用戶',
  meeting_bill_report_room_price: '會議室費用（元）',
  meeting_bill_report_svc_price: '會議服務費用（元）',
  meeting_bill_report_total_price: '總計（元）',
  price_free: '免費',

  // web端菜单栏
  menu_meeting_booking: '會議預約',
  menu_meetings: '會議列表',
  menu_system_configuration: '系統配置',
  menu_cole_management: '角色管理',
  menu_meeting_panel_management: '展板管理',
  menu_meeting_room_management: '會議室管理',
  menu_meeting_service_management: '會議服務管理',
  menu_device_danagement: '設備管理',
  menu_interface_setting: '接口設置',
  menu_log_lanagement: '日誌管理',
  menu_report: '統計報表',
  menu_room_usage_report: '會議室明細查詢',
  menu_user_usage_report: '用戶預訂查詢',
  menu_abnormal_room_report: '會議室數據統計',
  menu_abnormal_user_report: '用戶預訂統計',
  menu_meeting_report: '會議預約報表',
  menu_workday_management: '工作日管理',
  menu_system_management: '系統管理',
  menu_enterprise_info: '企業信息',
  menu_meeting_panel_monitor_img: '展板監控',
  menu_meeting_panel_monitor: '展板監控',
  menu_fault_statistics: '故障統計',
  menu_approval: '會議審批',
  menu_meeting_approval: '會議審批',
  menu_meeting_service_approval: '會議服務審批',
  menu_department_user_management: '組織用戶管理',
  menu_panel_alarm: '展板告警',
  menu_personal_information: '個人信息',
  menu_enterprise_setting: '企業信息配置',
  menu_meeting_release_report: '會議釋放統計',
  menu_room_occupy_report: '會議室佔用情況',
  menu_meeting_bill_report: '會議計費報表',

};



// WEBPACK FOOTER //
// ./src/i18n/zh_HK/index.js